import React, { useEffect, useState } from "react";
import axios from "axios";
import { settings } from "../../helpers/settings";
import authHeader from "../../helpers/functions/auth-header";
import { toast } from "../../helpers/swal";
import { Link } from "react-router-dom";
const linkStyle = {
    color: "blue",
    textDecoration: "none",
    fontWeight: 500,
    transition: "all 0.2s ease-in-out"
  };
  
  const linkHoverStyle = {
    textDecoration: "underline"
  };
  
const MyFilesPage = () => {
 
  const [files, setFiles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());
  const [selectedMonth, setSelectedMonth] = useState(new Date().getMonth() + 1);
  const [totalRollHeight, setTotalRollHeight] = useState(0);
  const [monthlyData, setMonthlyData] = useState([]);

  const user_id = localStorage.getItem("user_id");

  useEffect(() => {
    fetchFiles(selectedYear, selectedMonth);
    fetchTotalRollHeight(selectedYear, selectedMonth);
    fetchYearlyRollHeight(selectedYear);
  }, [selectedYear, selectedMonth]);

  const fetchFiles = async (year, month) => {
    setLoading(true);
    try {
      const response = await axios.get(
        `${settings.apiURL}/get_user_files_by_month.php?user_id=${user_id}&year=${year}&month=${month}`,
        { headers: authHeader() }
      );
      if (response.data.success) {
        setFiles(response.data.files);
      } else {
        setFiles([]);
      }
    } catch (error) {
      toast("Failed to fetch files", "error");
    } finally {
      setLoading(false);
    }
  };

  const fetchTotalRollHeight = async (year, month) => {
    try {
      const response = await axios.get(
        `${settings.apiURL}/get_total_roll_height_by_month.php?user_id=${user_id}&year=${year}&month=${month}`,
        { headers: authHeader() }
      );
      if (response.data.success) {
        setTotalRollHeight(response.data.total_roll_height);
      }
    } catch (error) {
      toast("Failed to fetch roll height", "error");
    }
  };

  const fetchYearlyRollHeight = async (year) => {
    try {
      const response = await axios.get(
        `${settings.apiURL}/get_total_roll_height_by_year.php?user_id=${user_id}&year=${year}`,
        { headers: authHeader() }
      );
      if (response.data.success) {
        setMonthlyData(response.data.monthly_data);
      }
    } catch (error) {
      toast("Failed to fetch yearly roll height", "error");
    }
  };
  const getDownloadLink = (fileId) => {
    return `https://drive.google.com/uc?id=${fileId}&export=download`;
  };
  
  

  return (
    <div className="container mt-4">
      
      {/* 🏠 Home butonu ortalanmış başlıkla birlikte */}
  <div className="text-center mb-4">
    <h2>My Files</h2>
    <Link to="/home" className="btn btn-outline-primary mt-2">
      🏠 Home
    </Link>
  </div>

      <div className="d-flex justify-content-between mb-3">
        <div>
          <label>Select Year:</label>
          <select
            className="form-select"
            value={selectedYear}
            onChange={(e) => setSelectedYear(e.target.value)}
          >
            {[...Array(5)].map((_, i) => {
              const year = new Date().getFullYear() - i;
              return (
                <option key={year} value={year}>
                  {year}
                </option>
              );
            })}
          </select>
        </div>

        <div>
          <label>Select Month:</label>
          <select
            className="form-select"
            value={selectedMonth}
            onChange={(e) => setSelectedMonth(e.target.value)}
          >
            {[
              "January",
              "February",
              "March",
              "April",
              "May",
              "June",
              "July",
              "August",
              "September",
              "October",
              "November",
              "December",
            ].map((month, index) => (
              <option key={index + 1} value={index + 1}>
                {month}
              </option>
            ))}
          </select>
        </div>

        <div className="border p-3">
          <h5>Total Roll Height</h5>
          <p>{totalRollHeight.toFixed(2)} inches</p>
        </div>
      </div>

      <h4>Monthly Roll Heights</h4>
      <table className="table table-bordered">
        <thead>
          <tr>
            <th>Month</th>
            <th>Total Roll Height (inches)</th>
          </tr>
        </thead>
        <tbody>
          {monthlyData.map((data, index) => (
            <tr key={index}>
              <td>
                {new Date(selectedYear, data.month - 1).toLocaleString(
                  "default",
                  { month: "long" }
                )}
              </td>
              <td>{data.total_roll_height.toFixed(2)}</td>
            </tr>
          ))}
        </tbody>
      </table>

      {loading ? (
        <p>Loading files...</p>
      ) : (
        <table className="table table-bordered table-striped mt-3">
          <thead>
            <tr>
              <th>File Name</th>
              <th>Uploaded Date</th>
              <th>Uploaded Time</th>
              <th>Folder Name</th>
              <th>Roll Height</th>
              <th>Upload Status</th>
              <th>File Status</th>
            </tr>
          </thead>
          <tbody>
            {files.length > 0 ? (
              files.map((file, index) => (
                <tr key={index}>
                <td>
  <a 
    href={file.download_link} 
    target="_blank" 
    rel="noopener noreferrer"
    className="text-primary text-decoration-underline"
  >
    {file.file_name}
  </a>
</td>


                  <td>{file.uploaded_date}</td>
                  <td>{file.uploaded_time}</td>
                  <td>{file.folderName}</td>
                  <td>{file.inch_height.toFixed(2)}</td>
                  <td
                    style={{
                      backgroundColor:
                        file.success == 1 ? "lightgreen" : "red",
                    }}
                  >
                    {file.success == 1 ? "DONE" : "ERROR"}
                  </td>
                  <td
                    style={{
                      backgroundColor:
                        file.IsPrinted && file.IsPrinted !== "Not Printed"
                          ? "lightgreen"
                          : "red",
                    }}
                  >
                    {file.IsPrinted && file.IsPrinted !== "Not Printed"
                      ? file.IsPrinted
                      : "Not Printed"}
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="7" className="text-center">
                  No files found for selected date.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default MyFilesPage;
